import React, { Component } from 'react';
import Advert from './Advert';
import Immutable from 'immutable';
import TopTags from './TopTags';
import 'whatwg-fetch';
import SheComHLogo from "./SheComHorizontalLogo";
import FTopTags from "./FTopTags";
import SheMomContentHubAdvert from './Advert/SheMomContentHubAdvert';
import TrendingPic from "./TrendingPic";
import classNames  from "classnames";


class Articles extends Component {

	 constructor(){
		  super();
		  this.state = {
			  list:Immutable.List([]),
              page:1,
              searchTxt:( document.querySelector('meta[name="searchTxt"]') ? document.querySelector('meta[name="searchTxt"]').content : false ),
			  loading:false,
			  nextPage:true,
			  articleColumn:2,
			  tagList: []
		  }

          let page = document.querySelector('meta[name="page"]').content;
		  this.page = page;

		  this.isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
		  this.parentCategory = document.querySelector('meta[name="category"]')? document.querySelector('meta[name="category"]').content : '';

		  let popularTag = document.getElementById('popular-tag-mobile-top') && document.getElementById('popular-tag-mobile-top').dataset? document.getElementById('popular-tag-mobile-top').dataset.tags : '';
		  this.tagDataset = popularTag? JSON.parse(popularTag) : [];

          this.dfpList = [];
		  this.dfpCount = 0;
		  this.pagePlacement = page == 'home' ? 'homepage' : 'channels'
		  this.getLatestArticles = this.getLatestArticles.bind(this);
		  this.isScrolledIntoView = this.isScrolledIntoView.bind(this);
		  this.handleScroll = this.handleScroll.bind(this);
		  this.extractHostname = this.extractHostname.bind(this);
		  this.getChannelURL = this.getChannelURL.bind(this);
		  this.dfpUpdate = this.dfpUpdate.bind(this);
		  this.dfpReady = this.dfpReady.bind(this);
		  this.getTags = this.getTags.bind(this);
	}
	getLatestArticles() {
        const {page, loading, searchTxt, nextPage, articleColumn} = this.state;
        const {author, catId, section, apiLabel, baseurl, postId,year} = this.props;

        let that = this;

		if (!loading && nextPage) {
			let params;

			if (section == 'she-promotes') {
				params = {
					promote: section,
					page: page
				};
			}
			else if (section == 'she-trials') {
				params = {
					trail: section,
					page: page
				};
			}
			else if (section == 'secret-talk') {
				params = {
					secret_talk: 1,
					page: page
				};
			} else if (section == 'term') {
				params = {
					term: document.querySelector('meta[name="term"]').content,
					page: page,
					offset: 13
				};
				this.setState({searchTxt: document.querySelector('meta[name="term"]').content});
			} else if (section == 'shefluencer') {
                params = {
                    endpoint: document.querySelector('meta[name="endpoint"]').content,
                    page: page
                };
            } else if (section == 'beautyaward') {
				params = {
					term:'beautyawardvoting',
					page: page-1,
					offset: 0,
					year: year,
				};
				this.setState({searchTxt: document.querySelector('meta[name="term"]').content});
			}
			else if (section == 'shemomaward') {
				params = {
					term:'shemomaward',
					page: page-1,
					offset: 0,
					year: year,
				};
				this.setState({searchTxt: document.querySelector('meta[name="term"]').content});
			} else if(postId ==624247){
				params = {
					term: ['shefitness','fitness','sports','運動','減肥','減肥方法','餐單','減肥餐單','巴黎奧運','奧運','get-set-glow'],
					page: page,

				};
			}else if (postId ==631883){
				params = {
					term: ['shehealth', 'health', '排毒', 'NMN', '益生菌', '減肥方法', '濕疹', '念珠菌', '陰道炎', '尿道炎', '腸道健康', '便秘', '月經', 'M痛', '脫髮', '白髮', '膽固醇', '乳癌', '癌症', '健康', '血糖', '卡路里'],
					page: page,

				};
			}

			// else if (section == 'beautyaward2') {
			// 	params = {
			// 		term:'beautyawardvoting2',
			// 		page: page-1 ,
			// 		offset: 0
			// 	};
			// 	this.setState({searchTxt: document.querySelector('meta[name="term"]').content});
			// }  else if (section == 'beautyaward3') {
			// 	params = {
			// 		term:'beautyawardvoting3',
			// 		page: page-1,
			// 		offset: 0
			// 	};
			// 	this.setState({searchTxt: document.querySelector('meta[name="term"]').content});
			// }
			else if (searchTxt) {
				params = {
					search: decodeURIComponent(searchTxt),
					page: page
				};
			} else if (author != '') {
				params = {
					author: author,
					page: page
				};
			} else if (catId != 0) {
				params = {
					category: catId,
					page: page
				};
			} else if (postId == 534764 || (postId ==402113 && document.querySelector('meta[name="baseURL"]').content.indexOf('facelift.she.com') != -1)) {
				params = {
					term: ['mirror','error','Keung To 姜濤','Anson Lo 盧瀚霆','Edan Lui 呂爵安','Ian Chan 陳卓賢','Jer Lau 柳應廷','Anson Kong','Stanley Yau 邱士縉','Jeremy Lee 李駿傑','Lokman Yeung 楊樂文','Frankie Chan 陳瑞輝','Tiger Yau 邱傲然','Alton Wong 王智德','Fat Boy 梁業','193 郭嘉駿','DeeGor 何啟華','Poki 吳保錡'],
					page: page,

				};
			} else if (document.querySelector('meta[name="page-template"]') && document.querySelector('meta[name="page-template"]').content == 'taggroup.php') {
				params = {
					term: JSON.parse(document.querySelector('meta[name="tag-group"]').content),
					page: page,

				};
				this.setState({searchTxt: document.querySelector('meta[name="term"]').content});
			}else if (postId == 541649 ) {
				params = {
					term: ['Christmas2021','聖誕2021'],
					page: page,

				};
			}else {
				params = {
					home: 1,
					page: page
				};
			}

			let formData = new FormData();
			for (var k in params) {
				if (params.hasOwnProperty(k)) {
					formData.append(k, params[k]);
				}
			}

			this.setState({loading: true});

			if (document.getElementById('loading-bar')) {
				document.getElementById('loading-bar').className = '';
			}
			// Apply on all sites
			if (page == 1 /*&& (document.querySelector('meta[name="baseURL"]').content.indexOf('.she.com') != -1)*/ ) {

				that.setState({page: that.state.page + 1});
				that.setState({loading: false});

			} else {

				fetch(baseurl + '/wp-json/she-rest-api/' + apiLabel + '/', {
					method: "POST",
					body: formData
				}).then(function (res) {
					return res.json();
				})
				.then(function (response) {
					let arr = response.items;
					arr.forEach(function (item) {
						item.ad_post = false;
					});

					const test = arr;
					let toparr = test.slice(0, 4);
					let midarr = test.slice(4, 10);
					let botarr = test.slice(10, 13);
					let tmpOffset = 0;

					// insert banner items
					if (that.state.list.size == 0) {
						if (toparr.length >= articleColumn) {
							toparr.splice(articleColumn, 0, {ad_post: '300x250'});
							toparr.splice(2 * articleColumn + 1, 0, {ad_post: '300x250'});
							tmpOffset += 2
						}
						if (toparr.length > (3 * articleColumn + 1) + tmpOffset) {
							toparr.splice((2 * (articleColumn + 1)), 0, {ad_post: '300x250'});
							toparr.splice((3 * (articleColumn + 1)), 0, {ad_post: '300x250'});
							toparr.splice((4 * (articleColumn + 1)), 0, {ad_post: '300x250'});
							toparr.splice((5 * (articleColumn + 1)), 0, {ad_post: '300x250'});
						}
					} else {
						if (toparr.length >= articleColumn) {
							toparr.splice(articleColumn, 0, {ad_post: '300x250'});
							toparr.splice(2 * articleColumn + 1, 0, {ad_post: '300x250'});
							tmpOffset += 2
						}
						if (toparr.length > (3 * articleColumn + 1) + tmpOffset) {
							toparr.splice((2 * (articleColumn + 1)), 0, {ad_post: '300x250'});
							toparr.splice((3 * (articleColumn + 1)), 0, {ad_post: '300x250'});
							toparr.splice((4 * (articleColumn + 1)), 0, {ad_post: '300x250'});
							toparr.splice((5 * (articleColumn + 1)), 0, {ad_post: '300x250'});
						}
					}

					that.setState(prevState => ({
						list: prevState.list.push({toparr, midarr, botarr}),
						page: prevState.page + 1,
						loading: false
					}));


					if (document.querySelector('.btn-loadmore')) {
						document.querySelector('.btn-loadmore').className = document.querySelector('.btn-loadmore').className + ' load';
					}

					if (document.getElementById('loading-bar')) {
						document.getElementById('loading-bar').className = 'done';
					}

					if (!response.next) {
						if (document.querySelector('.btn-loadmore')) {
							document.querySelector('.btn-loadmore').style.display = 'none';
						}
					}

					if (dataLayer && that.state.page > 1) {
						let tmpPageURL = window.location.href;
						dataLayer.push({
							virtualPageTitle: document.title + ' (LoadMore)',
							virtualPageURL: tmpPageURL.replace(/^.*\/\/[^\/]+/, ''),
							event: 'VirtualPageview'
						});
					}

					if (window.splashAd && document.getElementById('ad_splash-frame') && document.getElementById('ad_splash-frame').style.display == 'none')
						googletag.pubads().refresh([window.splashAd]);

					that.setState({nextPage: response.next})

				}).catch(function (error) {
					console.error(error);
				});

			}

		}
	}

	componentDidMount(){
		this.getLatestArticles();
		if(this.state.searchTxt == ''){
            window.addEventListener('scroll', this.handleScroll);
        }
		if (this.page == 'home' || this.page == 'category' || this.page == 'single') {
			this.getTags(this.tagDataset);
		}
	}

	componentWillUnmount(){
		window.removeEventListener('scroll', this.handleScroll);
	}

    dfpUpdate(){
        this.dfpCount++;
    }

    dfpReady(adunit){
        this.dfpList.push(adunit)

		if(this.dfpCount == this.dfpList.length){
            googletag.pubads().refresh(this.dfpList);
            this.dfpCount = 0;
            this.dfpList = [];
		}
	}

	isScrolledIntoView(elm,scrolltop){
		if(typeof elm == 'undefined') return;
        let docViewTop = scrolltop;
        let docViewBottom = docViewTop + ( window.outerHeight==0 ? window.innerHeight : window.outerHeight );

        let elemTop = elm.getBoundingClientRect().top+docViewTop;
        let elemBottom = elemTop + elm.getBoundingClientRect().height;

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

	handleScroll(evnt){
		let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		if(this.isScrolledIntoView(document.querySelectorAll('.block-article-loadmore')[0],scrollTop)){
			if(document.querySelector('.btn-loadmore')){
				document.querySelector('.btn-loadmore').className = document.querySelector('.btn-loadmore').className+' load';
			}
			this.getLatestArticles();
		}
	}

    extractHostname(url) {
        var hostname;
        //find & remove protocol (http, ftp, etc.) and get hostname

        if (url.indexOf("://") > -1) {
            hostname = url.split('/')[2];
        }
        else {
            hostname = url.split('/')[0];
        }

        //find & remove port number
        hostname = hostname.split(':')[0];
        //find & remove "?"
        hostname = hostname.split('?')[0];

        return hostname;
    }

    getChannelURL(label, url){
		let tmpURL = '';

		if(label!='she-mom' &&  label!='she-brides' && label!='kChannel' && label != 'luxshery'){
            tmpURL = '/'+label
		}else{
			tmpURL = ( url.indexOf('https://') == -1 ? 'http://' : 'https://' ) + this.extractHostname(url)
		}

		return tmpURL
	}

	compileURL( name, url ) {
		if (!url) url = location.href
		name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
		let regexS = "[\\?&]"+name+"=([^&#]*)";
		let regex = new RegExp( regexS );
		let results = regex.exec( url );
		return results == null ? null : results[1];
	}

	getTags(data){
		let that = this;

		if (this.state.tagList && this.state.tagList.length) {
		} else if (data.length) {
			that.setState({tagList: data});
		} else {
			fetch('/wp-json/she-rest-api/getHottestTags/', {
				method: "GET",
			}).then(function (res) {
				return res.json();
			}).then(function (response) {
				let arr = response.items.tags;
				that.setState({tagList: arr});
			}).catch(function (error) {
				console.error(error);
			});
		}
	}

	renderGrid(item,index){
		const { theme, catId, subcat } = this.props;
		const { tagList } = this.state;
		let tmp
		let tmpGTMLabel = 'H';
		let that = this;
		let extraIcon = ''
		let extraRibbon = ''


		if(catId!=0){
			if(subcat==0){
				tmpGTMLabel = 'C'
			}else{
				tmpGTMLabel = 'SC'
			}
		}
        if(item.search_post){
            item.format=item.pagemap.metatags[0]['article:format'];
		}
		if(item.format=='video'){
            extraIcon = <div className="extra-icon">
						<i className="icon-play-01"></i>
					  </div>
		}
		if(item.format=='promote'){
            extraIcon = <div className="extra-icon">
						<i className="icon-gift"></i>
					  </div>
		}

		// category "shedates" only
		if(catId == 267343){
            if(item.format=='progress'){
                extraRibbon = <div className="ribbon ribbon-top-left in-progress"><span>In Progress</span></div>
                extraIcon = <a href={item.url}>
                    <div className="join-now">立即登記<i className="icon-arr_right-01"></i></div>
                </a>
            }else if(item.format=='full'){
                extraRibbon = <div className="ribbon ribbon-top-left full"><span>Full</span></div>
            }else{
                extraRibbon = <div className="ribbon ribbon-top-left past-event"><span>Past Event</span></div>
            }
		}

        if(!item.ad_post){
			tmp = 	<div className="grid-article">
				<div className="single-article-blk">
					<div className="whole-article-blk">
					<a href={this.getChannelURL(item.category_slug, item.url)}>
						<div className={"cattag "+item.category_slug}>
							{item.category_name}
						</div>
					</a>
					<a href={item.url} title={item.post_title}>
						<div className="img-container">
							<div className={classNames('img-bg', {['img-bg--format-' + item.format]: item.format})} style={{backgroundImage : "url(" + item.thumbnail_mobile+")"}}></div>
							<img className="img-cell" src={item.thumbnail_mobile} alt={item.post_title}/>
						</div>


					</a>

					<div className="article-title-container">
						<a href={item.url} title={item.post_title}>
							<h2 className={"article-title "+item.category_slug} dangerouslySetInnerHTML={{__html: item.post_title}}/>
						</a>
					</div>
					</div>

				</div>

				{/*<a href={item.url} onClick={ () => that.linkInteractions(item.url,tmpGTMLabel+'/List')} title={item.post_title}>*/}
				{/*	<div className="thumb-img-container">*/}
				{/*		<img className="thumb-img-cell" src={item.thumbnail_mobile} alt={item.post_title}/>*/}
				{/*	</div>*/}
				{/*</a>*/}
				{/*<div className="desc-grid-article Abel">*/}
				{/*	{extraIcon}*/}
				{/*	<div className="clearfix">*/}

				{/*		<ol className="info-list">*/}
				{/*			<li><a className={item.category_slug} href={this.getChannelURL(item.category_slug, item.url)} style={{ color:item.category_color }} dangerouslySetInnerHTML={{ __html:item.category_name }}></a></li>*/}
				{/*			<li>by <a href={item.author_url}>{item.author_name}</a></li>*/}
				{/*			<li>{item.post_date}</li>*/}
				{/*		</ol>*/}

				{/*	</div>*/}
				{/*	<a href={item.url} onClick={ () => that.linkInteractions(item.url,tmpGTMLabel+'/List')} title={item.post_title}>*/}
				{/*		<h2 className="grid-article-title"  dangerouslySetInnerHTML={{ __html:item.post_title }}></h2>*/}
				{/*	</a>*/}
				{/*</div>*/}
			</div>
		}


		// nestlemomme >>> empty it
		else if(catId === '7287'){
			tmp = (
				<div className="grid-ads text-center">
					<div className={classNames("ad_300x250", (index % 2) === 0 ? 'desktop-visible' : 'mobile-visible')}>
						<SheMomContentHubAdvert tag="nestlemomme" position={setNum === 1 ? 'firstMediumRectangle' : 'loopMediumRectangle'} dfpReady={this.dfpReady} dfpUpdate={this.dfpUpdate} />
					</div>
				</div>
			);
		}

		// nestlebb >>> empty it
		else if (['7289', '7339', '7338'].includes(catId)) {
			tmp = (
				<div className="grid-ads text-center">
					<div className={classNames("ad_300x250", (index % 2) === 0 ? 'desktop-visible' : 'mobile-visible')}>
						<SheMomContentHubAdvert tag="nestlemomme" position={setNum === 1 ? 'firstMediumRectangle' : 'loopMediumRectangle'} dfpReady={this.dfpReady} dfpUpdate={this.dfpUpdate} />
					</div>
				</div>
			);
		}
		else if(item.ad_post==='300x250'){
			let setNum = ( index<3 ? 1 : 2 );
			setNum = 2;
			tmp = (
				<div className="grid-ads text-center">
					<div className={classNames("ad_300x250", (index % 2) === 0 ? 'desktop-visible' : 'mobile-visible')}>
						<Advert dfpReady={this.dfpReady} dfpUpdate={this.dfpUpdate} position={setNum === 1 ? 'firstMediumRectangle' : 'loopMediumRectangle'} />
					</div>
				</div>
			);
		}else{
			tmp = <div className="grid-ads text-center">
					<div className="ad-placeholder"></div>
				</div>
		}

		return tmp
	}

	linkInteractions(url,type){
            if(dataLayer)
                dataLayer.push({event: 'linksection', virtualPageURL: url, linkSection: type});
	}

	 render() {
		 const { list, searchTxt, articleColumn, page ,tagList} = this.state;
		 const { section, catId,theme } = this.props;
		 let that = this;
		 let tmpArr = [];
		 let fullWidthCount = 0;
		 let adcount =1;
         // Apply on all sites
         // if(document.querySelector('meta[name="baseURL"]').content.indexOf('.she.com') != -1 || document.querySelector('meta[name="baseURL"]').content.indexOf('shemom.com') != -1){
             fullWidthCount++;
         // }
		 let loadBtn = '';

		 // if(this.state.searchTxt == ''){
		 	loadBtn = <div className="grid-article-content grid-article-content-loadmore">
                <div className="block-article-loadmore" onClick={this.getLatestArticles}>
                    <div className="btn btn-loadmore text-center Abel">
                        <div className="btn-loadmore-over"></div>
                        <div className="btn-loading">
                            <span className="modal-pulsate" id="modal-bit-loader"></span>
                        </div>
                        <span>load more<i className="icon-arr_down-01"></i></span>
                    </div>
                </div>
            </div>;
		 // }

		 let toptag ='';
		 if (this.page == 'home' || this.page == 'category'){
		 	if (this.isMobile){
				toptag = <div className={"popular-tag-mobile"}>
					<TopTags theme={theme} page={this.pagePlacement} position={'side'} catName={this.parentCategory} tagList={tagList}/>
				</div>
			}else{
				toptag = <div className={"popular-tag-mobile"}>
					<FTopTags theme={theme} page={this.pagePlacement} position={'side'} catName={this.parentCategory} tagList={tagList}/>
				</div>
			}
		 }else if(this.page == 'single'){
			 toptag =<div className={this.isMobile? "popular-tag-mobile":"popular-tag-desktop popular-tag-desktop-home"}>
				 <TopTags theme={theme} page={this.pagePlacement} position={'side'} catName={this.parentCategory} tagList={tagList}/>
			 </div>
		 }else{
			 toptag =<div className="tagpadding"></div>
		 }
		 // toptag = (this.page == 'home' || this.page == 'category' || this.page == 'single')?
			//  (
			//  	<div className={this.isMobile? "popular-tag-mobile":"popular-tag-desktop popular-tag-desktop-home"}>
			// 	 <TopTags theme={theme} page={this.pagePlacement} position={'side'} catName={this.parentCategory} tagList={tagList}/>
			//  </div>)
			//  : ''


		 if(list.size){
			 var classlist = document.querySelector('body').classList;

			 switch (classlist[0]) {
		 		// she.com
		 		case 'beauty': var color = '#6D4840'; break;
		 		case 'fashion': var color = '#6B1E17'; break;
		 		case 'entertainment': var color = '#4A4252'; break;
		 		case 'hair': var color = '#614737'; break;
		 		case 'health': var color = '#596247'; break;
		 		case 'living': var color = '#917736'; break;
		 		case 'love': var color = '#6A372D'; break;

		 		// shemom.com
		 		case 'babygrowth': var color = '#bd8f86'; break;
		 		case 'babymetabolism': var color = '#966e40'; break;
		 		case 'celeb-family': var color = '#e7d6d3'; break;
		 		case 'fashion-and-beauty': var color = '#4f433f'; break;
		 		case 'hot-topics': var color = '#d9c0bb'; break;
		 		case 'lifestyle': var color = '#957773'; break;
		 		case 'motherhood': var color = '#a97f7d'; break;
		 		case 'nestlemomme': var color = '#43388a'; break;
		 		case 'she-promotes': var color = '#bd8f86'; break;

				// brides.she.com
				case 'celeb': var color = '#6D826D'; break;
				case 'guides': var color = '#233E1C'; break;
				case 'secret-talk-2': var color = '#9EAB9E'; break;
				case 'style-beauty': var color = '#859197'; break;
				case 'tools': var color = '#658187'; break;
				case 'wife-able': var color = '#8F989A'; break;
				case 'utility-list': var color = '#ffffff'; break;

				 default: var color = '#EEEBEB'; break;
			 }

			 if (document.querySelector('body').classList.contains('xmas')){
				 var color = '#6B1E17';
			 }

			 var enable = (document.querySelector('meta[name="baseURL"]').content.indexOf('www.she.com') != -1 || document.querySelector('meta[name="baseURL"]').content.indexOf('facelift.she.com') != -1)

             return(
				<div>
					{

						list.map(function({toparr, midarr, botarr},index){

							return(

							<div>
							<div className="padding-div">

								{toptag}
								<Advert position="loopLeaderboard" />
								<div className="ad-article-blk">{

									toparr.map(function(post, indexn){

										tmpArr.push(post);
										if(((tmpArr.length===articleColumn+1) && indexn!==0) || ( indexn>=toparr.length-1)){

											const tmpGridsArticle = tmpArr.filter(tmpItem => !tmpItem.ad_post).map((tmpItem, tmpIdx) => (<div key={tmpIdx} className="grid-article-list">{that.renderGrid(tmpItem, indexn)}</div>));
											const tmpGridsAd = tmpArr.filter(tmpItem => tmpItem.ad_post).map((tmpItem, tmpIdx) => (<div key={tmpIdx} className="grid-article-list">{that.renderGrid(tmpItem, indexn)}</div>));

											tmpArr = [];

											let tmpAds = '';
											if(fullWidthCount==2){
												//fullWidthCount = 0;
											}

											if(fullWidthCount==0){
												tmpAds =
													<div className={section == 'she-promotes' ? 'she-promotes' : ''}>
														<div className="ad_970x90">
															<Advert dfpUpdate={that.dfpUpdate} dfpReady={that.dfpReady} position="firstLeaderboard" />
														</div>
														{/*}
														<h2 className="text-center Raleway highlights" style={{ display:(section=='she-promotes' || catId!=0 && that.props.replaceTitle=='highlights' ? 'none' : 'block' )}}>
															{( 	!searchTxt && section!='term' ?
																<span>{ that.props.replaceTitle }</span>:
																<span>results of { decodeURIComponent(searchTxt) }</span>
															)}
														</h2>
														*/}
													</div>
											}

											fullWidthCount++;
											return (
												<React.Fragment>
													{tmpAds}
													<div className="grid-article-content">{tmpGridsArticle}</div>
													<div className="grid-article-ad">{tmpGridsAd}</div>
												</React.Fragment>
											);

										}

									})
								}</div>

								{Array.isArray(midarr) && midarr.length > 0 ? (
								<div className="mid-article-blk">
									{
										midarr.map(function(post, indexn){
											return(
												<div className="single-article-blk" key={indexn}>

													<a href={post.url} title={post.post_title}>
														<div className="img-container">
															<div className={classNames('img-bg', {['img-bg--format-' + post.format]: post.format})}
																 style={{backgroundImage : "url(" + post.thumbnail_mobile+")"}}></div>
															<img className="img-cell" src={post.thumbnail_mobile} alt={post.post_title}/>
														</div>
													</a>
													<div className="article-title-container">
														<a href={that.getChannelURL(post.category_slug, post.url)}>
															<div className={"cattag "+post.category_slug}>
																{post.category_name}
															</div>
														</a>
														<a href={post.url} title={post.post_title}>
															<h2 className="article-title">{post.post_title}</h2>
														</a>
													</div>
												</div>
											)

										})
									}
								</div>
							) : null}
							</div>

							{Array.isArray(botarr) && botarr.length > 0 ? (
								<div className="bottom-article-blk">
									{/*<img src="../assets-2021/img/homegreybanner.png" className="btmbg"/>*/}
									<div className="botbgdiv">
										<SheComHLogo theme={theme} color={color} />
									</div>


									<div className="padding-div">
										{
											botarr.map(function(post, indexn){
												return(
													<div className="single-article-blk">
														<div className="whole-article-blk">
														<a href={that.getChannelURL(post.category_slug, post.url)}>
															<div className={"cattag "+post.category_slug}>
																{post.category_name}
															</div>
														</a>
														<a href={post.url} title={post.post_title}>
															<div className="img-container">
																<div className={classNames('img-bg', {['img-bg--format-' + post.format]: post.format})}
																	 style={{backgroundImage : "url(" + post.thumbnail_mobile+")"}}></div>
																<img className="img-cell" src={post.thumbnail_mobile} alt={post.post_title}/>
															</div>
														</a>
														<div className="article-title-container">
															<a href={post.url} title={post.post_title}>
																<h2 className={"article-title "+post.category_slug}>{post.post_title}</h2>
															</a>
														</div>
														</div>
													</div>
												)

											})
										}
									</div>
								</div>
							): null}
								{/*<TrendingPic theme={theme} page= {index +1} enable ={enable}/>*/}
								</div>
							)

						})
					}

					{loadBtn}

				</div>

			 );

         //Apply on all sites
		 }else if( page <= 2 /* && (document.querySelector('meta[name="baseURL"]').content.indexOf('.she.com') != -1)*/){
			 return <div>
                 <div className="grid-article-content grid-article-content-loadmore">
                     <div className="block-article-loadmore" onClick={this.getLatestArticles}>
                         <div className="btn btn-loadmore text-center Abel">
                             <div className="btn-loadmore-over"></div>
                             <div className="btn-loading">
                                 <span className="modal-pulsate" id="modal-bit-loader"></span>
                             </div>
                             <span>load more<i className="icon-arr_down-01"></i></span>
                         </div>
                     </div>
                 </div>
			 </div>
		 }else{

             return <div></div>
         }

	 }
}

export default Articles;



// WEBPACK FOOTER //
// ./src/Articles.js